import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Loading from './loading';

import Icon from '../icon/icons/icon';
import { expandMore, expandLess } from './icons';

class Expand extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        expanded: PropTypes.bool
    }

    state = {
        expanded: this.props.expanded,
        loading: this.props.loading
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(props)
    }

    render() {
        if(this.state.loading) {
            return <Loading />
        }
        return this.state.expanded ? <Icon svg={expandLess} /> : <Icon svg={expandMore} />
    }
}

export default Expand
